import type { TagProps } from 'antd';

export type DocumentStatusKey =
  | 'UPLOADED'
  | 'RECEIVED'
  | 'PENDING'
  | 'PROCESSING'
  | 'APPROVED'
  | 'REJECTED'
  | 'FAILED'
  | 'ARCHIVED'
  | 'MISSING'
  | 'SENT'
  | 'CONFIRMED';

export type DocumentStatusMeta = {
  label: string;
  color: NonNullable<TagProps['color']>;
};

const DOCUMENT_STATUS_META: Record<DocumentStatusKey, DocumentStatusMeta> = {
  UPLOADED: { label: 'Загружен', color: 'blue' },
  RECEIVED: { label: 'Получен', color: 'green' },
  PENDING: { label: 'Ожидает', color: 'gold' },
  PROCESSING: { label: 'Обрабатывается', color: 'processing' },
  APPROVED: { label: 'Подтвержден', color: 'green' },
  REJECTED: { label: 'Отклонен', color: 'red' },
  FAILED: { label: 'Ошибка', color: 'red' },
  ARCHIVED: { label: 'Архив', color: 'default' },
  MISSING: { label: 'Ожидает', color: 'gold' },
  SENT: { label: 'Отправлен', color: 'blue' },
  CONFIRMED: { label: 'Подтвержден', color: 'green' },
};

const ALIASES: Record<string, DocumentStatusKey> = {
  OPEN: 'PENDING',
  ACTIVE: 'PENDING',
  WAITING: 'PENDING',
  IN_PROGRESS: 'PROCESSING',
  DONE: 'APPROVED',
  COMPLETED: 'APPROVED',
  CANCELLED: 'REJECTED',
  ERROR: 'FAILED',
};

export function resolveDocumentStatusMeta(status: string | null | undefined): DocumentStatusMeta {
  const raw = String(status || '').trim().toUpperCase();
  if (!raw) {
    return { label: '—', color: 'default' };
  }
  const key = (DOCUMENT_STATUS_META[raw as DocumentStatusKey]
    ? raw
    : ALIASES[raw] ?? raw) as DocumentStatusKey;
  return DOCUMENT_STATUS_META[key] ?? { label: '—', color: 'default' };
}

export function resolveDocumentStatusLabel(status: string | null | undefined): string {
  return resolveDocumentStatusMeta(status).label;
}
